import { render, staticRenderFns } from "./ApiV2.vue?vue&type=template&id=4ab7fabf&scoped=true&"
import script from "./ApiV2.vue?vue&type=script&lang=js&"
export * from "./ApiV2.vue?vue&type=script&lang=js&"
import style0 from "./ApiV2.vue?vue&type=style&index=0&id=4ab7fabf&prod&lang=css&"
import style1 from "./ApiV2.vue?vue&type=style&index=1&id=4ab7fabf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7fabf",
  null
  
)

export default component.exports